<form class="container-fluid" [formGroup]="ExemptVendorForm">
  @if (addingExemptVendor) {
    <div class="row">
      <div class="col">
        <h2>Add Compliance Exempt Vendor</h2>
      </div>
    </div>
  }
  <div class="row g-3">
    <div class="col">
      <h3>Company Information</h3>
      <hr />
      <div class="row">
        <div class="col-2">
          <div class="form-check">
            <input
              id="issue1099"
              type="checkbox"
              class="form-check-input"
              formControlName="is1099Issued"
            />
            <label for="issue1099" class="form-check-label">Issue 1099?</label>
          </div>
        </div>
        <div class="col-3">
          <label for="legalName" class="form-label"
            >Compliance Exempt Vendor Type<span class="required-field-asterisk"
              >*</span
            ></label
          >
          <select
            class="form-select"
            formControlName="ExemptVendorTypeId"
            (change)="setExemptVendorType()"
          >
            @for (type of ExemptVendorTypes; track type) {
              <option [ngValue]="type.id">
                {{ type.type }}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label for="legalName" class="form-label"
            >Legal Name<span class="required-field-asterisk">*</span></label
          >
          <input
            type="text"
            class="form-control"
            id="legalName"
            formControlName="legalName"
          />
        </div>
        <div class="col-4">
          <label for="dba" class="form-label">DBA</label>
          <input
            type="text"
            class="form-control"
            id="dba"
            formControlName="dba"
          />
        </div>
        <div class="col-4">
          <label for="accountingId" class="form-label">Accounting Id</label>
          <input
            type="text"
            class="form-control"
            id="accountingId"
            formControlName="accountingId"
          />
        </div>
      </div>
      @if (localizationInfo && localizationInfo.country.label === 'US') {
        <div class="row align-items-center">
          <div class="col-3">
            <label for="taxStructure" class="form-label">Tax Structure</label>
            <select
              id="taxStructure"
              class="form-select"
              formControlName="companyType"
            >
              <option [ngValue]="null" disabled selected>Pick one...</option>
              @for (option of taxStructures; track option) {
                <option [ngValue]="option">
                  {{ option }}
                </option>
              }
            </select>
          </div>
          @if (
            ExemptVendorForm.controls.companyType &&
            ExemptVendorForm.controls.companyType.value ===
              'Limited Liability Company (LLC)'
          ) {
            <div class="col-3">
              <label for="llcType" class="form-label">LLC Type</label>
              <select
                id="llcType"
                class="form-select"
                formControlName="llcType"
              >
                <option [ngValue]="null" disabled selected>Pick one...</option>
                @for (option of llcTypes | keyvalue; track option) {
                  <option [ngValue]="option.value">
                    {{ option.key }}
                  </option>
                }
              </select>
            </div>
          }
          <div class="col-3">
            <label for="taxSelection" class="form-label"
              >Company EIN (Tax ID)
              @if (isEINRequired) {
                <span class="required-field-asterisk">*</span>
              }
            </label>
            <input
              type="text"
              class="form-control"
              id="taxSelection"
              placeholder="__-_______"
              [inputMask]="einMask"
              formControlName="ein"
            />
          </div>
          @if (
            (ExemptVendorForm.controls.companyType.value ===
              'Limited Liability Company (LLC)' &&
              ExemptVendorForm.controls.llcType.value ===
                'disregardedEntity') ||
            ExemptVendorForm.controls.companyType.value ===
              'Sole Proprietorship'
          ) {
            <div class="col-3">
              <label for="taxSelection" class="form-label"
                >Company SSN (Tax ID)
                @if (isSSNRequired) {
                  <span class="required-field-asterisk">*</span>
                }
              </label>

              @if (
                !editingExemptVendor ||
                !ExemptVendor?.ssn ||
                !hasSSNAccess ||
                (editingExemptVendor && (maskedSSN || fullSSN))
              ) {
                <input
                  type="text"
                  class="form-control"
                  id="taxSelection"
                  [placeholder]="
                    editingExemptVendor && ExemptVendor?.ssn && !hasSSNAccess
                      ? '***-**-****'
                      : '___-__-____'
                  "
                  [inputMask]="ssnMask"
                  formControlName="ssn"
                />
              }

              @if (
                editingExemptVendor &&
                ExemptVendor?.ssn &&
                hasSSNAccess &&
                !maskedSSN &&
                !fullSSN
              ) {
                <div class="d-flex align-items-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="viewSSN()"
                  >
                    View SSN
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }

      <div class="row">
        <div class="col-3">
          <label for="officePhone" class="form-label">Office Phone</label>
          <input
            type="text"
            class="form-control"
            id="officePhone"
            placeholder="(___)___-____"
            [inputMask]="phoneMask"
            formControlName="phone"
          />
        </div>
        <div class="col-3">
          <label for="website" class="form-label">Website</label>
          <input
            type="text"
            class="form-control"
            id="website"
            formControlName="website"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row g-3 mt-3">
    <div class="col">
      <h3>Address Information</h3>
      <hr />
      <div class="row" formGroupName="MailingAddress">
        <div class="col-3">
          <label for="mailingAddress" class="form-label">Mailing Address</label>
          <input
            type="text"
            class="form-control"
            id="mailingAddress"
            formControlName="address1"
          />
        </div>
        <div class="col-3">
          <label for="mailingAddress2" class="form-label"
            >Mailing Address 2</label
          >
          <input
            type="text"
            class="form-control"
            id="mailingAddress2"
            formControlName="address2"
          />
        </div>
        <div class="col-2">
          <label for="mailingCity" class="form-label">City</label>
          <input
            type="text"
            class="form-control"
            id="mailingCity"
            formControlName="city"
          />
        </div>
        <div class="col-2">
          <label for="mailingState" class="form-label">{{
            localizationInfo && localizationInfo.territory
              ? localizationInfo.territory.label
              : 'State'
          }}</label>
          <select class="form-select" formControlName="state">
            @for (item of states; track item) {
              <option [ngValue]="item.abbreviation">
                {{ item.name }}
              </option>
            }
          </select>
        </div>
        <div class="col-2">
          <label for="mailingZip" class="form-label">{{
            localizationInfo && localizationInfo.postalCode
              ? localizationInfo.postalCode.label
              : 'Zip'
          }}</label>
          <input
            type="text"
            class="form-control"
            id="mailingZip"
            formControlName="zip"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <div class="form-check">
            <input
              id="isMailingAndStreetSame"
              type="checkbox"
              class="form-check-input"
              (change)="onIsMailingAndStreetSameChange()"
              [checked]="isMailingAndStreetSame"
            />
            <label for="isMailingAndStreetSame" class="form-check-label"
              >Street Address & Mailing Address are the same</label
            >
          </div>
        </div>
      </div>

      <div class="row" formGroupName="StreetAddress">
        <div class="col-3">
          <label for="streetAddress" class="form-label">Street Address</label>
          <input
            type="text"
            class="form-control"
            id="streetAddress"
            formControlName="address1"
          />
        </div>
        <div class="col-3">
          <label for="streetAddress2" class="form-label"
            >Street Address 2</label
          >
          <input
            type="text"
            class="form-control"
            id="streetAddress2"
            formControlName="address2"
          />
        </div>
        <div class="col-2">
          <label for="streetCity" class="form-label">City</label>
          <input
            type="text"
            class="form-control"
            id="streetCity"
            formControlName="city"
          />
        </div>
        <div class="col-2">
          <label for="streetState" class="form-label">{{
            localizationInfo && localizationInfo.territory
              ? localizationInfo.territory.label
              : 'State'
          }}</label>
          <select class="form-select" formControlName="state">
            @for (item of states; track item) {
              <option [ngValue]="item.abbreviation">
                {{ item.name }}
              </option>
            }
          </select>
        </div>
        <div class="col-2">
          <label for="streetZip" class="form-label">{{
            localizationInfo && localizationInfo.postalCode
              ? localizationInfo.postalCode.label
              : 'Zip'
          }}</label>
          <input
            type="text"
            class="form-control"
            id="streetZip"
            formControlName="zip"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row g-3 mt-3" [formGroup]="primaryContact">
    <div class="col">
      <h3>Contact Information</h3>
      <hr />
      <div class="row g-3">
        <div class="col-4">
          <label for="firstName" class="form-label">First Name</label>
          <input
            type="text"
            class="form-control"
            id="firstName"
            formControlName="firstName"
          />
        </div>
        <div class="col-4">
          <label for="lastName" class="form-label">Last Name</label>
          <input
            type="text"
            class="form-control"
            id="lastName"
            formControlName="lastName"
          />
        </div>
        <div class="col-4">
          <label for="jobTitle" class="form-label">Job Title</label>
          <input
            type="text"
            class="form-control"
            id="jobTitle"
            formControlName="jobTitle"
          />
        </div>
      </div>
      <div class="row g-3">
        <div class="col-3">
          <label for="phone" class="form-label">Mobile / Primary Phone</label>
          <input
            type="tel"
            class="form-control"
            id="phone"
            placeholder="(___)___-____"
            [inputMask]="phoneMask"
            formControlName="phone1"
          />
        </div>
        <div class="col">
          <label for="ext" class="form-label">Ext.</label>
          <input
            type="tel"
            class="form-control"
            id="ext"
            formControlName="ext"
          />
        </div>
        <div class="col-3">
          <label for="phone2" class="form-label">Work / Secondary Phone</label>
          <input
            type="tel"
            class="form-control"
            id="phone2"
            placeholder="(___)___-____"
            [inputMask]="phoneMask"
            formControlName="phone2"
          />
        </div>
        <div class="col">
          <label for="ext2" class="form-label">Ext.</label>
          <input
            type="tel"
            class="form-control"
            id="ext2"
            formControlName="ext2"
          />
        </div>
        <div class="col-3">
          <label for="email" class="form-label">Email</label>
          <input
            type="email"
            class="form-control"
            id="email"
            formControlName="email"
          />
        </div>
      </div>
      <div class="row" formGroupName="StreetAddress">
        <div class="col-3">
          <label for="contactAddress" class="form-label">Address</label>
          <input
            type="text"
            class="form-control"
            id="contactAddress"
            formControlName="address1"
          />
        </div>
        <div class="col-3">
          <label for="contactAddress2" class="form-label">Address 2</label>
          <input
            type="text"
            class="form-control"
            id="contactAddress2"
            formControlName="address2"
          />
        </div>
        <div class="col-2">
          <label for="contactCity" class="form-label">City</label>
          <input
            type="text"
            class="form-control"
            id="contactCity"
            formControlName="city"
          />
        </div>
        <div class="col-2">
          <label for="contactState" class="form-label">{{
            localizationInfo && localizationInfo.territory
              ? localizationInfo.territory.label
              : 'State'
          }}</label>
          <select class="form-select" formControlName="state">
            @for (item of states; track item) {
              <option [ngValue]="item.abbreviation">
                {{ item.name }}
              </option>
            }
          </select>
        </div>
        <div class="col-2">
          <label for="contactZip" class="form-label">{{
            localizationInfo && localizationInfo.postalCode
              ? localizationInfo.postalCode.label
              : 'Zip'
          }}</label>
          <input
            type="text"
            class="form-control"
            id="contactZip"
            formControlName="zip"
          />
        </div>
      </div>
    </div>
  </div>

  @if (additionalContacts && additionalContacts.length > 0) {
    <div class="row mt-3">
      @for (item of additionalContacts; track item; let i = $index) {
        <div [formGroup]="additionalContacts[i]" class="row mt-3">
          <div class="col">
            <h3>Additional Contact Information</h3>
            <hr />
            <div class="row g-3">
              <div class="col-4">
                <label
                  for="{{ 'additionalContactFirstName' + i }}"
                  class="form-label"
                  >First Name</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'additionalContactFirstName' + i }}"
                  formControlName="firstName"
                />
              </div>
              <div class="col-4">
                <label
                  for="{{ 'additionalContactLastName' + i }}"
                  class="form-label"
                  >Last Name</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'additionalContactLastName' + i }}"
                  formControlName="lastName"
                />
              </div>
              <div class="col-4">
                <label
                  for="{{ 'additionalContactJobTitle' + i }}"
                  class="form-label"
                  >Job Title</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'additionalContactJobTitle' + i }}"
                  formControlName="jobTitle"
                />
              </div>
            </div>
            <div class="row g-3">
              <div class="col-3">
                <label
                  for="{{ 'additionalContactPhone' + i }}"
                  class="form-label"
                  >Mobile / Primary Phone</label
                >
                <input
                  type="tel"
                  class="form-control"
                  id="{{ 'additionalContactPhone' + i }}"
                  placeholder="(___)___-____"
                  [inputMask]="phoneMask"
                  formControlName="phone1"
                />
              </div>
              <div class="col">
                <label for="{{ 'additionalContactExt' + i }}" class="form-label"
                  >Ext.</label
                >
                <input
                  type="tel"
                  class="form-control"
                  id="{{ 'additionalContactExt' + i }}"
                  formControlName="ext"
                />
              </div>
              <div class="col-3">
                <label
                  for="{{ 'additionalContactPhone2' + i }}"
                  class="form-label"
                  >Work / Secondary Phone</label
                >
                <input
                  type="tel"
                  class="form-control"
                  id="{{ 'additionalContactPhone2' + i }}"
                  placeholder="(___)___-____"
                  [inputMask]="phoneMask"
                  formControlName="phone2"
                />
              </div>
              <div class="col">
                <label
                  for="{{ 'additionalContactExt2' + i }}"
                  class="form-label"
                  >Ext.</label
                >
                <input
                  type="tel"
                  class="form-control"
                  id="{{ 'additionalContactExt2' + i }}"
                  formControlName="ext2"
                />
              </div>
              <div class="col-3">
                <label
                  for="{{ 'additionalContactEmail' + i }}"
                  class="form-label"
                  >Email</label
                >
                <input
                  type="email"
                  class="form-control"
                  id="{{ 'additionalContactEmail' + i }}"
                  formControlName="email"
                />
              </div>
            </div>
            <div class="row" formGroupName="StreetAddress">
              <div class="col-3">
                <label
                  for="{{ 'additionalContactAddress' + i }}"
                  class="form-label"
                  >Address</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="contactAddress"
                  formControlName="address1"
                />
              </div>
              <div class="col-3">
                <label
                  for="{{ 'additionalContactAddress2' + i }}"
                  class="form-label"
                  >Address 2</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'additionalContactAddress2' + i }}"
                  formControlName="address2"
                />
              </div>
              <div class="col-2">
                <label
                  for="{{ 'additionalContactCity' + i }}"
                  class="form-label"
                  >City</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'additionalContactCity' + i }}"
                  formControlName="city"
                />
              </div>
              <div class="col-2">
                <label
                  for="{{ 'additionalContactState' + i }}"
                  class="form-label"
                  >{{
                    localizationInfo && localizationInfo.territory
                      ? localizationInfo.territory.label
                      : 'State'
                  }}</label
                >
                <select
                  id="{{ 'additionalContactState' + i }}"
                  class="form-select"
                  formControlName="state"
                >
                  @for (item of states; track item) {
                    <option [ngValue]="item.abbreviation">
                      {{ item.name }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-2">
                <label
                  for="{{ 'additionalContactZip' + i }}"
                  class="form-label"
                  >{{
                    localizationInfo && localizationInfo.postalCode
                      ? localizationInfo.postalCode.label
                      : 'Zip'
                  }}</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="{{ 'additionalContactZip' + i }}"
                  formControlName="zip"
                />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div class="aev-actions">
    <button type="button" class="btn btn-outline btn-sm" (click)="addContact()">
      <i class="bi bi-plus-lg me-1"></i>
      Add contact
    </button>
    <div class="action-row justify-end">
      <button type="button" class="btn btn-ghost" (click)="cancel()">
        Cancel
      </button>
      <button
        type="submit"
        [disabled]="isSaving"
        class="btn btn-primary"
        (click)="save()"
      >
        Save vendor
      </button>
    </div>
  </div>
</form>
